import React from 'react'
import { Grid } from '@material-ui/core'
import SpacingContainer from '../../common/Containers/Base/SpacingContainer'
import Paper from '../../common/Containers/Paper'
import Typography from '../../common/Typography'
import { useTrans } from '../../../services/i18n'
import LockOutlinedIcon from '@material-ui/icons/LockOutlined'

export default function AccessDenied() {
  const { trans } = useTrans()

  return (
    <SpacingContainer py={10} px={7}>
      <Paper component={SpacingContainer} px={5} py={10}>
        <Grid
          container
          alignItems="center"
          justifyContent="center"
          alignContent="center"
          direction="column"
        >
          <Typography
            color="hint"
            gutter="bottom2"
            align="center"
            component="div"
          >
            <LockOutlinedIcon style={{ fontSize: 64 }} />
          </Typography>

          <Typography
            variant="h1Medium"
            weight="300"
            gutter="title"
            component="h5"
            fontFamily="lexend"
            align="center"
          >
            {trans('access-denied')}
          </Typography>

          <Typography
            variant="body1"
            color="hint"
            align="center"
          >
            {trans('access-denied-description')}
          </Typography>
        </Grid>
      </Paper>
    </SpacingContainer>
  )
}
